import React from 'react';
import './VendaCard.css';

const VendaCard = ({ venda }) => {
  return (
    <div className="venda-card">
      <div className="venda-card-header">
        <h4>{venda.nome_do_logradouro}, {venda.numero}</h4>
        <p>{venda.bairro}</p>
      </div>
      <div className="venda-card-body">
        <div className="venda-card-item">
          <strong>Valor da Transação:</strong>
          <p>R$ {venda.valor_de_transacao.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
        </div>
<div className="venda-card-item">
  <strong>Data da Transação:</strong>
  <p>
    {venda.data_de_transacao
      ? (() => {
          const [ano, mes, dia] = venda.data_de_transacao.slice(0, 10).split('-');
          return `${dia}/${mes}/${ano}`;
        })()
      : ''}
  </p>
</div>
        <div className="venda-card-item">
          <strong>Área Construída:</strong>
          <p>{venda.area_construida_m2} m²</p>
        </div>
        <div className="venda-card-item">
          <strong>Área do Terreno:</strong>
          <p>{venda.area_do_terreno_m2} m²</p>
        </div>
        <div className="venda-card-item">
          <strong>Uso do Imóvel:</strong>
          <p>{venda.descricao_do_uso_iptu}</p>
        </div>
        {venda.valor_financiado > 0 && (
          <div className="venda-card-item">
            <strong>Valor Financiado:</strong>
            <p>R$ {venda.valor_financiado.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendaCard;
